module.exports = __webpack_public_path__ + "assets/img/3.0280c66e.png";